module.exports = __webpack_public_path__ + "img/reward_6.9497e84c.png";